<template>
  <section class="overflow-auto1 p-5 w-full" style="height: calc(100% - 9rem)">
    <div
      class="overflow-auto rounded-md border1 border-line h-full max-h-full"
    >
      <div class="flex 1px-3 1py-4 text-placeholder">
        <div class="px-3 py-4 border-b border-line" style="min-width: 10rem; max-width: 10rem">
          공정
        </div>
        <div class="px-3 py-4 border-b border-line" style="min-width: 12rem; max-width: 12rem">
          재료
        </div>
        <div class="px-3 py-4 border-b border-line" style="min-width: 13rem; max-width: 13rem">
          협력사
        </div>
        <div class="px-3 py-4 border-b border-line" style="min-width: 15rem; max-width: 15rem">
          장비
        </div>
        <div class="px-3 py-4 border-b border-line" style="min-width: 16.5rem; max-width: 16.5rem">
          출력크기(mm) x*y*z
        </div>
        <div class="px-3 py-4 border-b border-line" style="min-width: 5rem; max-width: 5rem">
          도색
        </div>
        <div class="px-3 py-4 border-b border-line" style="min-width: 5rem; max-width: 5rem">
          후처리
        </div>
        <div class="px-3 py-4 border-b border-line" style="min-width: 6rem; max-width: 6rem">
          단가비율
        </div>
        <div class="px-3 py-4 border-b border-line" style="min-width: 9rem; max-width: 9rem">
          최소비용(원)
        </div>
        <div class="px-3 py-4 border-b border-line" style="min-width: 9rem; max-width: 9rem">
          장비 이용료(원)
        </div>
        <div class="px-3 py-4 border-b border-line" style="min-width: 9rem; max-width: 9rem">
          재료단가(원)
        </div>
      </div>

      <process-item
        v-for="process in processList"
        :key="process.id"
        :process="process"
      ></process-item>

      <div class="flex">
        <div class="px-3 py-2 border-r border-line" style="min-width: 10rem; max-width: 10rem">
          <div class="flex w-full cs-form" data-height="xs">
            <input
              class=""
              v-model="processName"
              type="text"
              placeholder=""
              @keypress.enter="onAddProcess"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="mt-10 text-right">
      <loader-button
        ref="submit"
        class="w-56 cs-pd-btn-lg"
        :cssButton="'cs-btn-base'"
        @click="onSubmit"
      >
        <template v-slot:title><span>저장</span></template>
      </loader-button>
    </div>
  </section>
</template>

<script setup>
import {ref, onMounted} from "vue";
import {storeToRefs} from "pinia";
import {CompanyStore} from "../../store/company-store";
import LoaderButton from "../../components/LoaderButton.vue";
import ProcessItem from "./../components/process-item.vue";

const companyStore = CompanyStore();
const {processList} = storeToRefs(companyStore);

let processName = ref("");

onMounted(() => {
  companyStore.reqProcesses();
});

const onAddProcess = () => {
  companyStore.addProcess(processName.value);
  processName.value = "";
};

const onSubmit = () => {
  companyStore.submit();
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
